import styled from "@emotion/styled";
import LogoEU from "../../../../assets/images/european-union-logo.jpg";
import LogoPKIP from "../../../../assets/images/pkip-logo.png";
import { Link } from "react-router-dom";

const LogosContainer = styled.div`
  display: flex;
  gap: 1rem; /* space between logos */
  margin-top: 1.5rem; /* space under the button */
  position: relative;
`;

const Logo = styled.img`
  height: 100px; /* adjust as needed */
  width: auto;

  @media (max-width: 1024px) {
    height: 70px;
  }
`;

export const HeroLogos = () => (
  <LogosContainer>
    <Link to="/talleye">
      <Logo src={LogoEU} alt="European Union Logo" />
    </Link>
    <Link to="/talleye">
      <Logo src={LogoPKIP} alt="PKIP Logo" />
    </Link>
  </LogosContainer>
);
